import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FiLayout, FiSave } from 'react-icons/fi';
import AppModal from '../../common/AppModal';
import services from '../../services';

const btnCancel = {
    padding: '8px 20px',
    fontSize: '13px',
    fontWeight: '600',
    color: '#374151',
    backgroundColor: '#f3f4f6',
    border: '1.5px solid #e5e7eb',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
};

const btnSave = {
    padding: '8px 22px',
    fontSize: '13px',
    fontWeight: '600',
    color: '#fff',
    backgroundColor: '#1a7d3e',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
    boxShadow: '0 2px 6px rgba(26,125,62,0.3)',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
};

const inputBase = {
    width: '100%',
    height: '40px',
    padding: '0 12px',
    fontSize: '13.5px',
    color: '#111827',
    backgroundColor: '#fff',
    border: '1.5px solid #e5e7eb',
    borderRadius: '8px',
    outline: 'none',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
    boxSizing: 'border-box',
};

const inputFocus = {
    borderColor: '#1a7d3e',
    boxShadow: '0 0 0 3px rgba(26,125,62,0.12)',
};

const AddBoard = ({ onHide, show, getAllBoard, setBoardName, editId, setEditId }) => {
    const [boardInput, setBoardInput] = useState(setBoardName || '');
    const [focused, setFocused] = useState(false);

    const handleAddBoard = async () => {
        try {
            if (editId) {
                await services.board.UPDATE_BOARD_BY_ID(editId, { boardName: boardInput });
                setBoardInput('');
                setEditId('');
                toast.success('Board Update Successfully');
                getAllBoard();
                window.dispatchEvent(new Event('board:refresh'));
            } else {
                await services.board.CREATE_BOARD({ boardName: boardInput });
                setBoardInput('');
                toast.success('Board Create Successfully');
                getAllBoard();
                window.dispatchEvent(new Event('board:refresh'));
            }
        } catch (e) {
            toast.error(e?.response?.data?.message);
            console.error(e);
        }
    };

    const handleSave = () => {
        if (!boardInput) {
            toast.warning('Please Enter Board Name');
            return;
        }
        handleAddBoard();
        onHide();
    };

    return (
        <AppModal
            show={show}
            onClose={onHide}
            icon={<FiLayout size={17} color="#fff" />}
            title={editId ? 'Edit Board' : 'Add Board'}
            subtitle={editId ? 'Update the board name' : 'Enter a name for your new board'}
            maxWidth="480px"
            footer={
                <>
                    <button
                        style={btnCancel}
                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#e5e7eb'; }}
                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#f3f4f6'; }}
                        onClick={onHide}
                    >
                        Close
                    </button>
                    <button
                        style={btnSave}
                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
                        onClick={handleSave}
                    >
                        <FiSave size={13} />
                        {editId ? 'Update' : 'Save'}
                    </button>
                </>
            }
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <label style={{ fontSize: '12.5px', fontWeight: '600', color: '#374151', letterSpacing: '0.01em' }}>
                    Board Name
                    <span style={{ color: '#dc2626', marginLeft: '2px' }}>*</span>
                </label>
                <input
                    type="text"
                    placeholder="Enter board name"
                    value={boardInput}
                    onChange={(e) => setBoardInput(e.target.value.trimStart())}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleSave();
                        }
                    }}
                    style={{ ...inputBase, ...(focused ? inputFocus : {}) }}
                    autoFocus
                />
            </div>
        </AppModal>
    );
};

export default AddBoard;
